export function extendInitialProps(Component) {
  return async function (ctx) {
    let initialProps = {}
    if (Component.getInitialProps)
      initialProps = await Component.getInitialProps(ctx)

    return {
      ...initialProps,
    }
  }
}
